import { SwapRightOutlined } from "@ant-design/icons";
import { Divider } from "antd";
import React from 'react';
import { NavLink } from "react-router-dom";
import { datetime } from "../../../../../../util/library/datetime";
import { OPERATION_TYPE, SHORT_DATETIME_FORMAT } from "../../../../../../util/varibles/constants";
import Id from "../../../../../Operation/Id";
import Logo from "../../../../../Operation/Logo";
import OperationStatus from "../../../../../Operation/OperationStatus";
import { IPropsSearchItem } from "../constants";
import styles from "../style.module.scss";

interface IProps extends IPropsSearchItem {
}

const Harvest: React.FC<IProps> = (props) => {
    const {
        operation_code,
        site_name,
        factory_name,
        sub_operations,
        vessel_name,
        status,
        est_start_time,
        est_finish_time,
        tenant_id,
        id,
    } = props.data;

    const unitIds = sub_operations.map((item: any) => item.unit_id).join(', ');
    return <div className={styles['item-result']}>
        <NavLink to={`/operation/${tenant_id}/${id}`}>
            <div className={styles['line-info-item']}>
                <Logo type={OPERATION_TYPE.HARVEST} status={status} />
                <Id className='ml-[2px] mr-1' code={operation_code} status={status} />
                <span>{site_name + ' - ' + unitIds}</span>
                <SwapRightOutlined className='ml-2 mr-2 font-s3' />
                {factory_name}
            </div>
            <div className={styles['line-info-item']}>
                <span>{vessel_name}</span>
                <Divider className={styles['divider-line']} orientation="vertical" />
                <OperationStatus status={status} />
            </div>
            <div className={styles['line-info-item']}>
                {datetime(est_start_time).format(SHORT_DATETIME_FORMAT)}
                <SwapRightOutlined className='ml-2 mr-2 font-s3' />
                {datetime(est_finish_time).format(SHORT_DATETIME_FORMAT)}
            </div>
        </NavLink>
    </div>;
}

export default Harvest;
